var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('select-languages',{ref:"formLanguages",attrs:{"hasExternalSaveButton":"true"}}),_c('select-categories',{ref:"formCategories",attrs:{"hasExternalSaveButton":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }